import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {AgencyHeader} from "./AgencyHeader";
import {AgencyTabs} from "./AgencyTabs";
import {WebhookComponent} from "./webhook/WebhookComponent";
import {
    ANALYTICS_CHANNEL,
    GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL,
    SHOPIFY_CHANNEL,
    TIENDA_NUBE_CHANNEL,
    KLAVIYO_CHANNEL,
    WOOCOMMERCE_CHANNEL,
    VTEX_CHANNEL
} from "../channels/channels";
import {ChannelCredentialsList} from "./connections/ChannelCredentialsList";
import {AnalyticsComponent} from "./analytics/AnalyticsComponent";
import {LookerCCComponent} from "./looker_cc/LookerCCComponent";
import {EcommerceConnectionsComponent} from "./connections/EcommerceConnectionsComponent";
import {DataNodeComponent} from "./data_node/DataNodeComponent";
import {CreateControlLinesModal} from "./link_acocunts/CreateControlLinesModal";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';
import {toast} from "react-toastify";

const PAID_MEDIA_CHANNELS = [GOOGLE_CHANNEL, FACEBOOK_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL];

class AgencyConnectionsConfigurationContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            googleAccountAlreadyLinked: null,
            facebookAccountAlreadyLinked: null,
            loading: true,
            channelsAllowed: [],
            saving: false,
            showModalForChannel: null,
            showControlLinesModal: false,
            controlLinesAdAccounts: [],
            // Multi-credencial
            googleCredentials: null,
            facebookCredentials: null,
            tiktokCredentials: null,
            linkedinCredentials: null,
            ga4Credentials: null,
        };

        this.handleGA4ConnectionDeleted = this.handleGA4ConnectionDeleted.bind(this);
        this.handleAdAccountRemove = this.handleAdAccountRemove.bind(this);
        this.handleCredentialRemoved = this.handleCredentialRemoved.bind(this);
        this.handleControlLinesModalFinish = this.handleControlLinesModalFinish.bind(this);
    }

    redirectToAgencyRegisterPage() {
        this.props.history.push('/agency-register');
    }

    componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const justConnectedChannel = params.get('just_connected');
        const reconnectAdAccountId = params.get('reconnect_ad_account_id');

        this.updateConnectionsInformation(justConnectedChannel, reconnectAdAccountId);

        if (justConnectedChannel) {
            this.showCreateControlLinesModal(justConnectedChannel);
        }
    }

    showCreateControlLinesModal(channel) {
        new APIClient(API_URL + 'agency/connections/'+channel+'/new/').call('GET').then((response) => {
            if (response && response.status === 'OK') {
                const data = response.data;
                if (data.first_time_on_channel) {
                    this.setState({
                        showControlLinesModal: true,
                        controlLinesAdAccounts: data.ad_accounts
                    });
                }
            }
        });
    }

    handleControlLinesModalFinish(count) {
        const { t } = this.props;
        this.setState({ showControlLinesModal: false });
        if (count > 0) {
            toast.success(t('connections_component.control_lines_created', {count: count}));
        }
    }

    updateConnectionsInformation(reconnectChannel, reconnectAdAccountId) {
        new APIClient(API_URL + 'agency/connections/').call('GET').then((data) => {
            if (data.status === 'ERROR_NO_AGENCY') {
                alert(data['error_message']);
                this.redirectToAgencyRegisterPage()
            } else if (data.status === 'OK') {
                this.setState({
                    googleAccountAlreadyLinked: data.data.google_account_already_linked,
                    ga4AccountAlreadyLinked: data.data.ga4_account_already_linked,
                    facebookAccountAlreadyLinked: data.data.facebook_account_already_linked,
                    tiktokAccountAlreadyLinked: data.data.tiktok_account_already_linked,
                    linkedinAccountAlreadyLinked: data.data.linkedin_account_already_linked,
                    useGoogleScriptsForGA4: data.data.use_ga4_thou_scripts,
                    lookerCCEnabled: data.data.looker_cc_enabled,
                    dataNodeEnabled: data.data.data_node_enabled,
                    lookerCCApiKey: data.data.looker_cc_api_key,
                    dataNodeApiKey: data.data.data_node_api_key,
                    channelsAllowed: data.data.channels_allowed,
                    shopifyAdAccounts: data.data.shopify_ad_accounts_data,
                    tiendaNubeAdAccounts: data.data.tienda_nube_ad_accounts_data,
                    klaviyoAdAccounts: data.data.klaviyo_ad_accounts_data,
                    woocommerceAdAccounts: data.data.woocommerce_ad_accounts_data,
                    vtexAdAccounts: data.data.vtex_ad_accounts_data,
                    // Multi-credencial
                    googleCredentials: data.data.google_credentials || [],
                    facebookCredentials: data.data.facebook_credentials || [],
                    tiktokCredentials: data.data.tiktok_credentials || [],
                    linkedinCredentials: data.data.linkedin_credentials || [],
                    ga4Credentials: data.data.ga4_credentials || [],
                    loading: false
                }, () => {
                    if (reconnectChannel && reconnectAdAccountId) {
                        this.autoReassignCredential(reconnectChannel, reconnectAdAccountId);
                    }
                });
            }
        })
    }

    autoReassignCredential(channel, adAccountId) {
        const { t } = this.props;
        const credentialsMap = {
            [GOOGLE_CHANNEL]: this.state.googleCredentials,
            [FACEBOOK_CHANNEL]: this.state.facebookCredentials,
            [TIKTOK_CHANNEL]: this.state.tiktokCredentials,
            [LINKEDIN_CHANNEL]: this.state.linkedinCredentials,
        };

        const credentials = credentialsMap[channel];
        if (!credentials || credentials.length === 0) return;

        const newestCredential = credentials.reduce((newest, cred) =>
            cred.id > newest.id ? cred : newest
        );

        new APIClient(API_URL + `agency/ad-accounts/${adAccountId}/reassign-credential`).call('POST', {
            credential_id: newestCredential.id,
        }).then((data) => {
            if (data.status === 'ERROR') {
                toast.error(data.error_message || t('reconnect_modal.error_no_access'));
            } else {
                toast.success(t('reconnect_modal.auto_reassign_success'));
                this.updateConnectionsInformation();
            }
        }).catch(() => {
            toast.error(t('reconnect_modal.error_no_access'));
        });
    }

    handleGA4ConnectionDeleted() {
        const { t } = this.props;
        alert(t('agency_connections_configuration.ga4_disconnected_successfully'));
        this.setState({
            ga4AccountAlreadyLinked: false
        });
    }

    handleCredentialRemoved(channel, credentialId) {
        this.setState({ saving: true });
        new APIClient(`${API_URL}agency/credentials/${channel}/${credentialId}/`).call('DELETE').then((data) => {
            this.setState({ saving: false });
            if (data.status === 'ERROR') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateConnectionsInformation();
            }
        }).catch(() => {
            this.setState({ saving: false });
        });
    }

    handleAdAccountRemove(adAccountId) {
        this.setState({ saving: true });
        new APIClient(`${API_URL}agency/ad-accounts/${adAccountId}/disconnect`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                this.setState({ saving: false });
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.updateConnectionsInformation();
            }
        })
    }

    render() {
        return (
            <section className="section-content agency-page agency-connections-page">
                <AgencyHeader/>
                <AgencyTabs activeTab="-sixth"/>
                {this.renderPaidMediaConnections()}
                {this.renderEcommerceConnections()}
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    {this.renderGA4Component()}
                </div>
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    {this.renderLookerCCComponent()}
                </div>
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    {this.renderDataNodeComponent()}
                </div>
                <div className="section-body -wider h-items" style={{paddingBottom:'0em'}}>
                    <WebhookComponent />
                </div>
                <CreateControlLinesModal
                    isOpen={this.state.showControlLinesModal}
                    toggle={() => this.setState({showControlLinesModal: !this.state.showControlLinesModal})}
                    adAccounts={this.state.controlLinesAdAccounts}
                    onFinish={this.handleControlLinesModalFinish}
                />
            </section>
        )
    }

    renderPaidMediaConnections() {
        const credentialsMap = {
            [GOOGLE_CHANNEL]: this.state.googleCredentials,
            [FACEBOOK_CHANNEL]: this.state.facebookCredentials,
            [TIKTOK_CHANNEL]: this.state.tiktokCredentials,
            [LINKEDIN_CHANNEL]: this.state.linkedinCredentials,
        };

        return PAID_MEDIA_CHANNELS.map(channel => {
            if (!this.state.channelsAllowed.includes(channel))
                return null;

            return (
                <div key={channel} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <ChannelCredentialsList
                        channel={channel}
                        credentials={credentialsMap[channel]}
                        onCredentialRemoved={this.handleCredentialRemoved}
                    />
                </div>
            );
        });
    }

    renderEcommerceConnections() {
        const ecommerceChannels = [];

        if (this._agencyHasEcommerceChannel(SHOPIFY_CHANNEL)) {
            ecommerceChannels.push(
                <div key={SHOPIFY_CHANNEL} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <EcommerceConnectionsComponent channel={SHOPIFY_CHANNEL}
                                                   onAdAccountConnectionDeleted={this.handleAdAccountConnectionDeleted}
                                                   adAccountsDatas={this.state.shopifyAdAccounts}
                                                   onAdAccountConnectionCreated={this.handleAdAccountConnectionCreated}
                                                   doAdAccountRemove={this.handleAdAccountRemove}
                                                   isSaving={this.state.saving}
                    />
                </div>
            );
        }

        if (this._agencyHasEcommerceChannel(TIENDA_NUBE_CHANNEL)) {
            ecommerceChannels.push(
                <div key={TIENDA_NUBE_CHANNEL} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <EcommerceConnectionsComponent channel={TIENDA_NUBE_CHANNEL}
                                                   onAdAccountConnectionDeleted={this.handleAdAccountConnectionDeleted}
                                                   adAccountsDatas={this.state.tiendaNubeAdAccounts}
                                                   onAdAccountConnectionCreated={this.handleAdAccountConnectionCreated}
                                                   doAdAccountRemove={this.handleAdAccountRemove}
                                                   isSaving={this.state.saving}
                    />
                </div>
            );
        }

        if (this._agencyHasEcommerceChannel(KLAVIYO_CHANNEL)) {
            ecommerceChannels.push(
                <div key={KLAVIYO_CHANNEL} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <EcommerceConnectionsComponent channel={KLAVIYO_CHANNEL}
                                                   onAdAccountConnectionDeleted={this.handleAdAccountConnectionDeleted}
                                                   adAccountsDatas={this.state.klaviyoAdAccounts}
                                                   onAdAccountConnectionCreated={this.handleAdAccountConnectionCreated}
                                                   doAdAccountRemove={this.handleAdAccountRemove}
                                                   isSaving={this.state.saving}
                    />
                </div>
            );
        }

        if (this._agencyHasEcommerceChannel(WOOCOMMERCE_CHANNEL)) {
            ecommerceChannels.push(
                <div key={WOOCOMMERCE_CHANNEL} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <EcommerceConnectionsComponent channel={WOOCOMMERCE_CHANNEL}
                                                   onAdAccountConnectionDeleted={this.handleAdAccountConnectionDeleted}
                                                   adAccountsDatas={this.state.woocommerceAdAccounts}
                                                   onAdAccountConnectionCreated={this.handleAdAccountConnectionCreated}
                                                   doAdAccountRemove={this.handleAdAccountRemove}
                                                   isSaving={this.state.saving}
                    />
                </div>
            );
        }

        if (this._agencyHasEcommerceChannel(VTEX_CHANNEL)) {
            ecommerceChannels.push(
                <div key={VTEX_CHANNEL} className="section-body h-items" style={{paddingBottom: '0em'}}>
                    <EcommerceConnectionsComponent channel={VTEX_CHANNEL}
                                                   onAdAccountConnectionDeleted={this.handleAdAccountConnectionDeleted}
                                                   adAccountsDatas={this.state.vtexAdAccounts}
                                                   onAdAccountConnectionCreated={this.handleAdAccountConnectionCreated}
                                                   doAdAccountRemove={this.handleAdAccountRemove}
                                                   isSaving={this.state.saving}
                    />
                </div>
            );
        }

        return ecommerceChannels;
    }

    _agencyHasEcommerceChannel(channel) {
        if (this.state.channelsAllowed === null)
            return false;

        return this.state.channelsAllowed.includes(channel);
    }

    renderGA4Component() {
        if (this.state.useGoogleScriptsForGA4)
            return <AnalyticsComponent />

        // GA4 usa ChannelCredentialsList (multi-credencial)
        if (this.state.channelsAllowed.includes(ANALYTICS_CHANNEL)) {
            return <ChannelCredentialsList
                channel={ANALYTICS_CHANNEL}
                credentials={this.state.ga4Credentials}
                onCredentialRemoved={this.handleCredentialRemoved}
            />;
        }
        return null;
    }

    renderLookerCCComponent() {
        return <LookerCCComponent apiKey={this.state.lookerCCApiKey}
                                  loading={this.state.loading}
                                  hasAccessToModule={this.state.lookerCCEnabled}
        />;
    }

    renderDataNodeComponent() {
        return <DataNodeComponent apiKey={this.state.dataNodeApiKey}
                                  loading={this.state.loading}
                                  hasAccessToModule={this.state.dataNodeEnabled}
        />;
    }
}

export default withRouterParams(withTranslation()(AgencyConnectionsConfigurationContent));
